import DownloadsDashboard from './DownloadsDashboard';

export default DownloadsDashboard; 
